export const FILTER_BY_OPTIONS = [
    {
        text: 'All',
        sortBy: 'modified',
        sortDirection: true,
        filterBy: '',
        key: 0
    },{
        text: 'Live',
        sortBy: 'modified',
        sortDirection: true,
        filterBy: 'live',
        key: 1
    },{
        text: 'Overdue',
        sortBy: 'modified',
        sortDirection: true,
        filterBy: 'overdue',
        key: 2
    },{
        text: 'Complete',
        sortBy: 'modified',
        sortDirection: true,
        filterBy: 'complete',
        key: 3
    },{
        text: 'Recurring',
        sortBy: 'modified',
        sortDirection: true,
        filterBy: 'recurring',
        key: 4
    },{
        text: 'Drafts',
        sortBy: 'modified',
        sortDirection: true,
        filterBy: 'unpublished',
        key: 5
    },{
        text: 'Archived',
        sortBy: 'modified',
        sortDirection: true,
        filterBy: 'archived',
        key: 6
    },{
        text: 'Stopped',
        sortBy: 'modified',
        sortDirection: true,
        filterBy: 'cancelled',
        key: 7
    },{
        text: 'Created by Me',
        sortBy: 'modified',
        sortDirection: true,
        filterBy: 'creator',
        key: 8
    }
];

export const SORT_BY_OPTIONS = [
    {
        text: 'Recently Edited',
        sortBy: 'lastEdited',
        sortDirection: true,
        key: 0
    },{
        text: 'Due Date',
        sortBy: 'dueDate',
        sortDirection: false,
        key: 4
    },{
        text: 'Status',
        sortBy: 'status',
        sortDirection: true,
        key: 3
    },{
        text: 'Name (a-z)',
        sortBy: 'name',
        sortDirection: false,
        key: 1
    },{
        text: 'Name (z-a)',
        sortBy: 'name',
        sortDirection: true,
        key: 2
    }
];

export const RECURRING_FREQUENCY_OPTIONS = [
    {
        text: 'None',
        value: 'none',
        key: 0
    }, {
        text: 'Daily',
        value: 'daily',
        key: 1
    }, {
        text: 'Weekly',
        value: 'weekly',
        key: 2
    }, {
        text: 'Monthly',
        value: 'monthly',
        key: 3
    }, {
        text: 'Yearly',
        value: 'yearly',
        key: 4
    }
];

export const ASSIGNMENT_STATES = {
    NONE: "none",
    PUBLISHED: "published",
    IN_PROGRESS: "in_progress",
    UNPUBLISHED: "unpublished",
    CANCELLED: "cancelled",
    COMPLETED: "completed"
};

export const ASSIGNMENT_STATES_LOOKUP = {
    none: 'None',
    published: 'Published',
    in_progress: 'In Progress',
    unpublished: 'Draft',
    cancelled: 'Stopped',
    completed: 'Completed'
};

export const ASSIGNMENT_STATUSES = {
    NO_PROGRESS: "no_progress",
    PARTIAL_PROGRESS: "partial_progress",
    COMPLETE: "complete",
    OVERDUE: "overdue"
};

export const ASSIGNMENT_STATUSES_LOOKUP = {
    no_progress: 'No Progress',
    partial_progress: 'In Progress',
    complete: 'Completed',
    overdue: 'Overdue'
};



// WEBPACK FOOTER //
// ./src/containers/AssignmentsPage/constants.js